/* ========== K7 FLOCKEN SET ========== */
(function () {
  function k7FormatMoney(cents) {
    var n = typeof cents === 'number' ? cents : parseInt(String(cents).replace(/[^\d-]/g, ''), 10);
    if (Number.isNaN(n)) return '';
    if (window.themeVariables && window.themeVariables.settings) {
      var settings = window.themeVariables.settings;
      var format = settings.currencyCodeEnabled ? settings.moneyWithCurrencyFormat : settings.moneyFormat;
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        try {
          var out = window.Shopify.formatMoney(n, format);
          if (out && out.indexOf('{{') === -1) return out;
        } catch (e) {}
      }
    }
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR'
      }).format(n / 100);
    } catch (e2) {
      return (n / 100).toFixed(2).replace('.', ',') + '€';
    }
  }

  function k7ParsePct(value, fallback) {
    var n = parseFloat(String(value == null ? '' : value).replace(',', '.'));
    return Number.isFinite(n) ? n : fallback;
  }

  function k7DiscountPct(qty, discount4, discount6) {
    if (qty >= 6) return discount6;
    if (qty >= 4) return discount4;
    return 0;
  }

  function k7DisplaySale(root, qty, fallback) {
    var mapped = parseInt(root.getAttribute('data-k7-sale-' + qty) || '0', 10);
    return mapped > 0 ? mapped : fallback;
  }

  function k7BaseCents(root) {
    var base = parseInt(root.getAttribute('data-k7-base') || '0', 10);
    return base > 0 ? base : 1999;
  }

  function k7WunschsetSale(root, prices) {
    var qty = prices.length;
    var base = k7BaseCents(root);
    var discount4 = k7ParsePct(root.getAttribute('data-k7-discount-4'), 12.468);
    var discount6 = k7ParsePct(root.getAttribute('data-k7-discount-6'), 20);
    var sum = 0;
    var surcharge = 0;
    prices.forEach(function (price) {
      sum += price;
      if (price > base) surcharge += price - base;
    });
    if (qty >= 6) {
      var lock = parseInt(root.getAttribute('data-k7-sale-6') || '0', 10);
      if (lock < 1) return sum;
      return Math.round((lock * qty) / 6) + Math.round((surcharge * (100 - discount6)) / 100);
    }
    if (qty >= 4) {
      return Math.round((sum * (100 - discount4)) / 100);
    }
    return sum;
  }

  function k7UnitFinal(unitPrice, pct) {
    if (!pct) return unitPrice;
    return Math.floor((unitPrice * (100 - pct)) / 100);
  }

  function k7QtyLabel(qty, singular, plural) {
    return qty + ' ' + (qty === 1 ? singular : plural);
  }

  function k7SelectedFlavors(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-k7-flavor].is-selected'));
  }

  function k7UpdateBuyButtons(root, enabled) {
    var formId = root.getAttribute('data-k7-form-id');
    if (!formId) return;
    var form = document.getElementById(formId);
    var buttons = [];
    if (form) {
      buttons = buttons.concat(Array.prototype.slice.call(form.querySelectorAll('[type="submit"]')));
    }
    buttons = buttons.concat(Array.prototype.slice.call(document.querySelectorAll('[form="' + formId + '"][type="submit"]')));
    buttons.forEach(function (button) {
      if (!button) return;
      button.disabled = !enabled;
      button.setAttribute('aria-disabled', enabled ? 'false' : 'true');
    });
  }

  function k7UpdateCustomPrice(saleEl, compareEl, sale, compare, fromPrefix) {
    if (saleEl) saleEl.textContent = (fromPrefix ? 'ab ' : '') + k7FormatMoney(sale);
    if (!compareEl) return;
    if (!fromPrefix && compare > sale) {
      compareEl.textContent = k7FormatMoney(compare);
      compareEl.hidden = false;
      compareEl.classList.remove('hidden');
    } else {
      compareEl.textContent = '';
      compareEl.hidden = true;
      compareEl.classList.add('hidden');
    }
  }

  function k7UpdatePrice(root, sale, compare, savePct) {
    var saleEl = root.querySelector('[data-k7-price-sale]');
    var compareEl = root.querySelector('[data-k7-price-compare]');
    var saveEl = root.querySelector('[data-k7-price-save]');
    if (saleEl) saleEl.textContent = k7FormatMoney(sale);
    if (compareEl) {
      if (compare > sale) {
        compareEl.textContent = k7FormatMoney(compare);
        compareEl.hidden = false;
        compareEl.classList.remove('hidden');
      } else {
        compareEl.textContent = '';
        compareEl.hidden = true;
        compareEl.classList.add('hidden');
      }
    }
    if (saveEl) {
      if (savePct > 0) {
        saveEl.textContent = 'Spare ' + Math.round(savePct) + '%';
        saveEl.hidden = false;
        saveEl.classList.remove('hidden');
      } else {
        saveEl.textContent = '';
        saveEl.hidden = true;
        saveEl.classList.add('hidden');
      }
    }

    document.querySelectorAll('[data-bk-media-quick-atc-price]').forEach(function (block) {
      var quickSale = block.querySelector('[data-role="sale"]');
      var quickCompare = block.querySelector('[data-role="compare"]');
      if (quickSale) {
        quickSale.textContent = k7FormatMoney(sale);
        quickSale.classList.toggle('text-on-sale', compare > sale);
      }
      if (quickCompare) {
        if (compare > sale) {
          quickCompare.textContent = k7FormatMoney(compare);
          quickCompare.hidden = false;
          quickCompare.classList.remove('hidden');
        } else {
          quickCompare.textContent = '';
          quickCompare.hidden = true;
          quickCompare.classList.add('hidden');
        }
      }
    });
  }

  function k7SyncPresetCards(root) {
    var customMode = root.getAttribute('data-k7-mode') === 'custom';
    root.querySelectorAll('[data-k7-preset]').forEach(function (input) {
      var label = input.nextElementSibling;
      if (!label || !label.classList.contains('k7-flocken-set__preset')) return;
      label.classList.toggle('is-selected', !customMode && input.checked);
    });
  }

  function k7SyncOffer(root) {
    var mode = root.getAttribute('data-k7-mode') || 'preset';
    var discount4 = k7ParsePct(root.getAttribute('data-k7-discount-4'), 12.468);
    var discount6 = k7ParsePct(root.getAttribute('data-k7-discount-6'), 20);
    var singular = root.getAttribute('data-k7-unit-singular') || 'Dose';
    var plural = root.getAttribute('data-k7-unit-plural') || 'Dosen';
    var minCustom = parseInt(root.getAttribute('data-k7-min-custom') || '2', 10);
    var fromPrice = parseInt(root.getAttribute('data-k7-from-price') || '0', 10);
    var qtyBadge = root.querySelector('[data-k7-qty-badge]');
    var customFrom = root.querySelector('[data-k7-custom-from]');
    var customCompare = root.querySelector('[data-k7-custom-compare]');
    var custom = root.querySelector('[data-k7-custom]');
    var flavorsWrap = root.querySelector('[data-k7-flavors]');
    var toggle = root.querySelector('[data-k7-custom-toggle]');
    k7SyncPresetCards(root);

    if (mode === 'custom') {
      if (custom) custom.classList.add('is-open');
      if (flavorsWrap) flavorsWrap.hidden = false;
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'true');
        toggle.setAttribute('aria-pressed', 'true');
      }

      var selected = k7SelectedFlavors(root);
      var qty = selected.length;
      var compare = 0;
      var prices = [];
      selected.forEach(function (button) {
        var unit = parseInt(button.getAttribute('data-k7-price') || '0', 10);
        compare += unit;
        prices.push(unit);
      });
      var pct = k7DiscountPct(qty, discount4, discount6);
      var sale = k7WunschsetSale(root, prices);

      if (qtyBadge) qtyBadge.textContent = k7QtyLabel(Math.max(qty, minCustom), singular, plural);
      k7UpdateCustomPrice(customFrom, customCompare, qty > 0 ? sale : fromPrice, qty > 0 ? compare : 0, qty === 0);
      if (qty >= minCustom) {
        k7UpdatePrice(root, sale, compare, pct);
        k7UpdateBuyButtons(root, true);
      } else {
        k7UpdatePrice(root, fromPrice, fromPrice, 0);
        k7UpdateBuyButtons(root, false);
      }
      return;
    }

    if (custom) custom.classList.remove('is-open');
    if (flavorsWrap) flavorsWrap.hidden = true;
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-pressed', 'false');
    }

    var checked = root.querySelector('[data-k7-preset]:checked');
    var presetQty = checked ? parseInt(checked.getAttribute('data-k7-quantity') || '1', 10) : 1;
    var presetPrice = checked ? parseInt(checked.getAttribute('data-k7-price') || '0', 10) : fromPrice;
    var presetCompare = checked ? parseInt(checked.getAttribute('data-k7-compare') || String(presetPrice), 10) : presetPrice;
    var presetPct = k7DiscountPct(presetQty, discount4, discount6);
    if (presetCompare <= presetPrice && presetPct > 0) {
      presetCompare = Math.round((presetPrice * 100) / (100 - presetPct));
    }

    if (qtyBadge) qtyBadge.textContent = k7QtyLabel(presetQty, singular, plural);
    k7UpdateCustomPrice(customFrom, customCompare, fromPrice, 0, true);
    k7UpdatePrice(root, presetPrice, presetCompare, presetPct);
    k7UpdateBuyButtons(root, true);
  }

  function k7SetMode(root, mode) {
    if (root.getAttribute('data-k7-mode') !== mode) {
      root.setAttribute('data-k7-mode', mode);
    }
    k7SyncOffer(root);
  }

  function k7FormIdInput(root) {
    var form = document.getElementById(root.getAttribute('data-k7-form-id'));
    if (!form) return null;
    return form.elements.id || form.querySelector('input[name="id"]');
  }

  function k7FirstFlavorId(input) {
    if (!input) return '';
    var ids = String(input.getAttribute('data-k7-item-ids') || '').split(',');
    var first = String(ids[0] || '').trim();
    return first || '';
  }

  function k7ApplyPreset(root, input) {
    if (!root || !input || input.disabled || root._k7Applying) return;
    root._k7Applying = true;
    try {
      input.checked = true;
      var flavorId = k7FirstFlavorId(input);
      var idInput = k7FormIdInput(root);
      if (idInput && flavorId) {
        idInput.value = flavorId;
      }
      var parentVariantId = input.getAttribute('data-k7-parent-variant-id') || input.getAttribute('data-k7-variant-id');
      if (root.querySelector('variant-picker[update-url]') && parentVariantId) {
        try {
          var nextUrl = new URL(window.location.href);
          nextUrl.searchParams.set('variant', parentVariantId);
          window.history.replaceState({ path: nextUrl.toString() }, '', nextUrl.toString());
        } catch (e) {}
      }
      k7SetMode(root, 'preset');
    } finally {
      root._k7Applying = false;
    }
  }

  function k7PresetFlavorItems(input) {
    if (!input) return [];
    var ids = String(input.getAttribute('data-k7-item-ids') || '').split(',');
    var prices = String(input.getAttribute('data-k7-item-prices') || '').split(',');
    var items = [];
    ids.forEach(function (id, index) {
      var variantId = Number(String(id).trim());
      if (!variantId) return;
      items.push({
        id: variantId,
        price: parseInt(prices[index] || '0', 10) || 0
      });
    });
    return items;
  }

  function k7SelectedFlavorItems(root) {
    return k7SelectedFlavors(root).map(function (button) {
      return {
        id: Number(button.getAttribute('data-k7-variant-id')),
        price: parseInt(button.getAttribute('data-k7-price') || '0', 10)
      };
    }).filter(function (item) {
      return item.id;
    });
  }

  function k7BundleParent(root) {
    var handle = root.getAttribute('data-k7-parent-handle') || '';
    var image = root.getAttribute('data-k7-parent-image') || '';
    var variantId = '';
    if (root.getAttribute('data-k7-mode') === 'custom') {
      var custom = root.querySelector('[data-k7-custom]');
      if (custom) {
        variantId = custom.getAttribute('data-k7-parent-variant-id') || '';
        image = custom.getAttribute('data-k7-parent-image') || image;
      }
    } else {
      var checked = root.querySelector('[data-k7-preset]:checked');
      if (checked) {
        variantId = checked.getAttribute('data-k7-parent-variant-id') || checked.getAttribute('data-k7-variant-id') || '';
        image = checked.getAttribute('data-k7-parent-image') || image;
      }
    }
    return {
      handle: handle,
      image: image,
      variantId: variantId
    };
  }

  function k7FormQuantity(root) {
    var form = document.getElementById(root.getAttribute('data-k7-form-id'));
    if (!form) return 1;
    var qtyInput = form.querySelector('[name="quantity"]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    return qty > 0 ? qty : 1;
  }

  async function k7AddBundleItems(root, flavorItems, qty, bundleTitle) {
    if (!flavorItems.length || qty < 1) return;

    var discount4 = k7ParsePct(root.getAttribute('data-k7-discount-4'), 12.468);
    var discount6 = k7ParsePct(root.getAttribute('data-k7-discount-6'), 20);
    var singular = root.getAttribute('data-k7-unit-singular') || 'Dose';
    var plural = root.getAttribute('data-k7-unit-plural') || 'Dosen';
    var formQty = k7FormQuantity(root);
    var pct = k7DiscountPct(qty, discount4, discount6);
    var parent = k7BundleParent(root);
    var parentVariantId = parent.variantId ? Number(parent.variantId) : 0;
    var compare = 0;
    var sale = 0;
    var items = [];
    var prices = [];
    flavorItems.forEach(function (flavor) {
      if (!flavor.id || (parentVariantId && flavor.id === parentVariantId)) return;
      compare += flavor.price;
      sale += k7UnitFinal(flavor.price, pct);
      prices.push(flavor.price);
      items.push({
        id: flavor.id,
        quantity: formQty
      });
    });
    if (!items.length) return;
    if (root.getAttribute('data-k7-mode') === 'custom') {
      sale = k7WunschsetSale(root, prices);
    } else {
      sale = k7DisplaySale(root, qty, sale);
    }
    compare *= formQty;
    sale *= formQty;
    var totalQty = qty * formQty;

    var bundleGroup = String(root.getAttribute('data-k7-bundle-group') || 'FlockenSetAB');
    var bundleId = bundleGroup.replace(/-/g, '') + '-' + Date.now();
    var checked = root.querySelector('[data-k7-preset]:checked');
    var qtyLabel = (checked && checked.getAttribute('data-k7-qty-label')) || k7QtyLabel(totalQty, singular, plural);
    if (root.getAttribute('data-k7-mode') === 'custom') {
      qtyLabel = k7QtyLabel(totalQty, singular, plural);
    }
    var properties = {
      _BundleId: bundleId,
      _BundleGroup: bundleGroup,
      _BundleTitle: bundleTitle || root.getAttribute('data-k7-bundle-title') || 'Dein Wunschset',
      _BundleTotalQty: String(totalQty),
      _BundleAddonQty: String(totalQty),
      _BundleQtyLabel: qtyLabel,
      _BundleVariantTitle: qtyLabel,
      _BundleCompareAtPrice: String(compare),
      _BundleSalePrice: String(sale),
      _BundleHideSubtitle: 'true'
    };
    if (parent.variantId) properties._BundleParentVariantId = String(parent.variantId);
    if (parent.handle) properties._BundleParentHandle = String(parent.handle);
    if (parent.image) properties._BundleParentImage = String(parent.image);
    items.forEach(function (item) {
      item.properties = properties;
    });

    var cartDrawerElement = document.querySelector('cart-drawer');
    var sectionId = (cartDrawerElement && cartDrawerElement.getAttribute('data-section-id')) || 'cart-drawer';
    var sectionsToBundle = ['variant-added'];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections: sectionsToBundle }
    }));
    if (sectionsToBundle.indexOf(sectionId) === -1) sectionsToBundle.push(sectionId);

    var response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: items,
        sections: sectionsToBundle.join(',')
      })
    });
    if (!response.ok) {
      var errorData = await response.json();
      throw new Error(errorData.description || 'Failed to add items to cart');
    }

    var responseJson = await response.json();
    var cartContent = await (await fetch(window.Shopify.routes.root + 'cart.js')).json();
    if (!responseJson.sections || !responseJson.sections[sectionId]) {
      var cartDrawerResponse = await fetch(window.Shopify.routes.root + 'cart?section_id=' + sectionId);
      var cartDrawerHtml = await cartDrawerResponse.text();
      var tempDiv = document.createElement('div');
      tempDiv.innerHTML = cartDrawerHtml;
      var newCartDrawer = tempDiv.querySelector('#cart-drawer');
      if (newCartDrawer) {
        if (!responseJson.sections) responseJson.sections = {};
        responseJson.sections[sectionId] = newCartDrawer.outerHTML;
      }
    }
    if (!cartContent.sections) cartContent.sections = {};
    cartContent.sections = Object.assign(cartContent.sections, responseJson.sections || {});

    var productForm = document.getElementById(root.getAttribute('data-k7-form-id')) || document.querySelector('form[is="product-form"]');
    var formToUse = productForm || document.createElement('form');
    var formAdded = false;
    if (!productForm) {
      document.body.appendChild(formToUse);
      formAdded = true;
    }
    formToUse.dispatchEvent(new CustomEvent('variant:add', {
      bubbles: true,
      cancelable: true,
      detail: {
        items: responseJson.items || [responseJson],
        cart: cartContent
      }
    }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true,
      detail: {
        baseEvent: 'variant:add',
        cart: cartContent
      }
    }));
    if (formAdded) document.body.removeChild(formToUse);
  }

  function k7PreselectPreset(root) {
    if (!root || root.dataset.k7Preselected === 'true') return;
    var picker = root.querySelector('variant-picker[data-preselect-index]');
    if (!picker) return;
    if (new URLSearchParams(window.location.search).get('variant')) {
      root.dataset.k7Preselected = 'true';
      return;
    }

    var index = parseInt(picker.getAttribute('data-preselect-index'), 10) || 2;
    var inputs = Array.prototype.filter.call(root.querySelectorAll('[data-k7-preset]'), function (input) {
      return !input.disabled;
    });
    var target = inputs[Math.min(Math.max(index, 1), inputs.length) - 1];
    if (!target) return;

    root.dataset.k7Preselected = 'true';
    var idInput = k7FormIdInput(root);
    var alreadySynced = target.checked && idInput && String(idInput.value) === String(k7FirstFlavorId(target));
    if (alreadySynced) return;
    k7ApplyPreset(root, target);
  }

  function k7BindOffer(root) {
    if (!root || root.dataset.k7Bound === 'true') return;
    root.dataset.k7Bound = 'true';

    root.addEventListener('change', function (event) {
      var input = event.target;
      if (!input || !input.hasAttribute || !input.hasAttribute('data-k7-preset')) return;
      event.stopImmediatePropagation();
      k7ApplyPreset(root, input);
      if (document.activeElement === input) input.blur();
    }, true);

    root.addEventListener('click', function (event) {
      var label = event.target.closest('.k7-flocken-set__preset');
      if (label && root.contains(label)) {
        var input = label.previousElementSibling;
        if (input && input.hasAttribute('data-k7-preset') && !input.disabled) {
          k7ApplyPreset(root, input);
        }
        return;
      }

      if (event.target.closest('[data-k7-custom-toggle]')) {
        k7SetMode(root, 'custom');
        return;
      }

      var flavor = event.target.closest('[data-k7-flavor]');
      if (!flavor || !root.contains(flavor) || flavor.disabled) return;
      flavor.classList.toggle('is-selected');
      flavor.setAttribute('aria-pressed', flavor.classList.contains('is-selected') ? 'true' : 'false');
      k7SetMode(root, 'custom');
    });

    var formId = root.getAttribute('data-k7-form-id');
    var form = formId ? document.getElementById(formId) : null;
    if (form && form.dataset.k7CustomSubmit !== 'true') {
      form.dataset.k7CustomSubmit = 'true';
      form.addEventListener('submit', function (event) {
        var offer = document.querySelector('[data-k7-flocken-set][data-k7-form-id="' + formId + '"]');
        if (!offer) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        var addPromise;
        if (offer.getAttribute('data-k7-mode') === 'custom') {
          var minCustom = parseInt(offer.getAttribute('data-k7-min-custom') || '2', 10);
          var selected = k7SelectedFlavorItems(offer);
          if (selected.length < minCustom) return;
          addPromise = k7AddBundleItems(offer, selected, selected.length, offer.getAttribute('data-k7-bundle-title') || 'Dein Wunschset');
        } else {
          var checked = offer.querySelector('[data-k7-preset]:checked');
          var flavorItems = k7PresetFlavorItems(checked);
          var qty = flavorItems.length;
          if (checked) {
            var presetQty = parseInt(checked.getAttribute('data-k7-quantity') || '0', 10);
            if (presetQty > qty) qty = presetQty;
          }
          if (!flavorItems.length) return;
          addPromise = k7AddBundleItems(offer, flavorItems, qty, checked.getAttribute('data-k7-bundle-title') || offer.getAttribute('data-k7-bundle-title'));
        }
        addPromise.catch(function (error) {
          console.error(error);
        });
      }, true);
    }

    k7SyncOffer(root);
    k7PreselectPreset(root);
  }

  function k7InitFlockenSet() {
    document.querySelectorAll('[data-k7-flocken-set]').forEach(k7BindOffer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', k7InitFlockenSet, { once: true });
  } else {
    k7InitFlockenSet();
  }
  document.addEventListener('shopify:section:load', k7InitFlockenSet);
  document.addEventListener('product:rerender', function () {
    setTimeout(k7InitFlockenSet, 100);
  });
  document.addEventListener('variant:change', function () {
    document.querySelectorAll('[data-k7-flocken-set]').forEach(function (root) {
      if (root.getAttribute('data-k7-mode') === 'custom') return;
      k7SyncOffer(root);
    });
  });
})();
/* ========== END K7 FLOCKEN SET ========== */

/* ========== K7 ZUTATEN ========== */
(function () {
  function k7ZutatenSync(root) {
    var track = root.querySelector('[data-k7-zutaten-track]');
    var prev = root.querySelector('[data-k7-zutaten-dir="prev"]');
    var next = root.querySelector('[data-k7-zutaten-dir="next"]');
    if (!track || !prev || !next) return;
    var max = track.scrollWidth - track.clientWidth;
    var nav = root.querySelector('.k7-zutaten__nav');
    if (nav) nav.hidden = max <= 1;
    prev.disabled = track.scrollLeft <= 1;
    next.disabled = track.scrollLeft >= max - 1;
  }

  function k7ZutatenSyncAll() {
    document.querySelectorAll('[data-k7-zutaten]').forEach(k7ZutatenSync);
  }

  document.addEventListener('click', function (event) {
    var dirBtn = event.target.closest('[data-k7-zutaten-dir]');
    if (dirBtn) {
      var root = dirBtn.closest('[data-k7-zutaten]');
      var track = root && root.querySelector('[data-k7-zutaten-track]');
      var item = track && track.querySelector('.k7-zutaten__item');
      if (!track || !item || dirBtn.disabled) return;
      var styles = getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      var dir = dirBtn.getAttribute('data-k7-zutaten-dir') === 'next' ? 1 : -1;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollBy({
        left: dir * (item.getBoundingClientRect().width + gap),
        behavior: reduce ? 'auto' : 'smooth'
      });
      return;
    }
    if (event.target.closest('.bk-media-faq-accordion-btn')) {
      requestAnimationFrame(function () {
        requestAnimationFrame(k7ZutatenSyncAll);
      });
    }
  });

  document.addEventListener('scroll', function (event) {
    var track = event.target;
    if (!track || !track.closest || !track.hasAttribute || !track.hasAttribute('data-k7-zutaten-track')) return;
    var root = track.closest('[data-k7-zutaten]');
    if (root) k7ZutatenSync(root);
  }, true);

  window.addEventListener('resize', k7ZutatenSyncAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', k7ZutatenSyncAll, { once: true });
  } else {
    k7ZutatenSyncAll();
  }
  document.addEventListener('shopify:section:load', k7ZutatenSyncAll);
})();
/* ========== END K7 ZUTATEN ========== */
